import Link from 'next/link'
import React from 'react'

function BookaCall(data:any) {
  return (
   <section className='section theme_gray bookacall text-center'>
        <div className="container">
            <h2 data-aos="fade" data-aos-delay="100">{data?.data?.title}</h2>
            <p data-aos="fade" data-aos-delay="200">
                {data?.data?.description}
            </p>
            {data?.data?.bookCallButton?.url && (
              <Link href={data?.data?.bookCallButton?.url} className='cmn_btn' data-aos="fade-down" data-aos-delay="100"><span>{data?.data?.bookCallButton?.title}</span></Link>
            )}
        </div>
   </section>
  )
}

export default BookaCall
